import { Button } from "../Button/Button";
import "./BannerContent.scss"

const BannerContent = ({title, yellowTitle, boldText, img, buttonContent}) => {
  return (
		<div className="bannerContent--container">
			<div className="max-width bannerContent--content-container">
				<div>
					<h1 className="t1 c-white">
						{title}
						{yellowTitle && <span className="t1 c-yellow">{` ${yellowTitle}`}</span>}
					</h1>
					<p className="mt-10 t4 c-white">{boldText}</p>
					<Button type="button yellow" content={buttonContent} />
				</div>
				<div>
					<img src={img.src} alt={img.alt} />
				</div>
			</div>
		</div>
	);
}

export default BannerContent
